import { render, staticRenderFns } from "./EmergencyCtaTall.vue?vue&type=template&id=a2b76d30"
import script from "./EmergencyCtaTall.vue?vue&type=script&lang=js"
export * from "./EmergencyCtaTall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports